import { Box } from "@mui/material";
import CustomText from "components/common/CustomText/CustomText";
import useGlobalStyles from "styles/globalStyles";
import useStyles from "./styles";
import CustomLabel from "components/common/CustomLabel/CustomLabel";
import { colors } from "styles/colors";

interface Props {
  label: string;
  value?: string | boolean | null;
}

export default function CaseInfoItem({ label, value }: Props) {
  const styles = useStyles();
  const globalStyles = useGlobalStyles();

  const renderValue = () => {
    if (value === null || value === undefined) return 'N/A';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed || trimmed === '[]' || trimmed.toLowerCase() === 'undefined') return 'N/A';
      return trimmed;
    }
    return String(value);
  };


  return (
    <Box>
      {label && (
        <CustomText text={label} fontSize={15} fontWeight={600}/>
      )}
      <Box >
        <CustomText text={renderValue()} fontSize={15} color={colors.black} fontWeight={500}/>
      </Box>
    </Box>
  )
}
